// Custom search filter enhancements

class SearchFilterEnhancements {
  constructor() {
    this.priceRangeBlurTimeouts = new Map();
    this.init();
  }

  init() {
    console.log('Search filter enhancements loading...');
    
    // Wait for DOM and existing scripts to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhance());
    } else {
      // Use a small delay to ensure facets.js has loaded
      setTimeout(() => this.enhance(), 200);
    }
  }

  enhance() {
    console.log('Enhancing search filters...');
    this.enhanceFacetRemoval();
    this.enhancePriceRanges();
  }

  enhanceFacetRemoval() {
    console.log('Enhancing facet removal...');
    
    // Find all facet-remove elements and enhance their anchor clicks
    document.querySelectorAll('facet-remove a').forEach(anchor => {
      // Remove existing click handlers and add our own
      const newAnchor = anchor.cloneNode(true);
      anchor.parentNode.replaceChild(newAnchor, anchor);
      
      newAnchor.addEventListener('click', (event) => {
        event.preventDefault();
        console.log('Facet remove clicked, href:', newAnchor.href);
        
        // Navigate directly to the URL to clear the filter
        if (newAnchor.href && newAnchor.href !== '#') {
          window.location.href = newAnchor.href;
        }
      });
    });
  }

  enhancePriceRanges() {
    console.log('Enhancing price ranges...');
    
    // Find all price range containers
    document.querySelectorAll('price-range').forEach(priceRange => {
      const inputs = priceRange.querySelectorAll('input[type="text"]');
      console.log('Found price range with', inputs.length, 'inputs');
      
      inputs.forEach(input => {
        // Add blur and focus handlers for smart submission
        input.addEventListener('focus', () => {
          console.log('Price input focused');
          this.clearBlurTimeout(priceRange);
        });
        
        input.addEventListener('blur', () => {
          console.log('Price input blurred');
          this.handlePriceBlur(priceRange);
        });
      });
    });
  }

  clearBlurTimeout(priceRange) {
    if (this.priceRangeBlurTimeouts.has(priceRange)) {
      clearTimeout(this.priceRangeBlurTimeouts.get(priceRange));
      this.priceRangeBlurTimeouts.delete(priceRange);
    }
  }

  handlePriceBlur(priceRange) {
    // Clear any existing timeout for this price range
    this.clearBlurTimeout(priceRange);
    
    // Set a timeout to check if focus moved to another input in the same range
    const timeoutId = setTimeout(() => {
      const activeElement = document.activeElement;
      const isStillInPriceRange = priceRange.contains(activeElement) && 
                                  activeElement.tagName === 'INPUT';
      
      console.log('Price blur timeout executed, still in range:', isStillInPriceRange);
      
      if (!isStillInPriceRange) {
        // Focus has left the price range, trigger form submission
        const form = priceRange.closest('form');
        if (form) {
          console.log('Triggering form submission for price range');
          form.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      
      // Clean up the timeout reference
      this.priceRangeBlurTimeouts.delete(priceRange);
    }, 150); // Slightly longer delay to ensure focus has time to move
    
    this.priceRangeBlurTimeouts.set(priceRange, timeoutId);
  }
}

// Initialize the enhancements
new SearchFilterEnhancements();